module.exports = __webpack_public_path__ + "1.5.0-unryo/img/speedtest.4c5602d4.png";